window.addEventListener('load', () => {
    window.$ =jQuery;
    new RightMenu();
    new ScrollTo();
    $('a').tooltip();
    $('img').tooltip();
    $('img').tooltip();
    $('abbr').tooltip();
    $('acronym').tooltip();
});